import { createContext } from 'react';

import { SetOrRemoveFavouriteApiResponse } from '~extension/favourite/model/SetOrRemoveFavourite';
import FavouriteDto from '../model/FavouriteDto';

const FavouriteContext = createContext<{
  isFavouriteAddonEnabled: () => boolean;
  showFavouritesToggle: boolean;
  onSetShowFavouritesToggle: (_show: boolean) => void;
  addContentFavourite: (_id: string) => Promise<FavouriteDto[]>;
  removeContentFavourite: (_id: string) => Promise<FavouriteDto[]>;
  addAssetFavourite: (_id: string) => Promise<SetOrRemoveFavouriteApiResponse>;
  removeAssetFavourite: (_id: string) => Promise<SetOrRemoveFavouriteApiResponse>;
}>(null);

export default FavouriteContext;
